import {
  BtnGroup,
  BtnToolbar,
  Button,
  ButtonAction,
  Datepicker,
  type HookFormMethods,
  HookFormResolver,
  IconTitle,
  Row,
  TextArea
} from '@dec/shared';
import { InputCursorText } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { type DisbursementContent } from '../../models/Disbursement';

interface DisbursementForm {
  disbursementDate: Date;
  comments: string;
}

interface DisbursementFormProps {
  onSubmit: (values: DisbursementContent) => void;

  onCancel: () => void;
}

export const DisbursementForm = ({ onSubmit, onCancel }: DisbursementFormProps) => {
  const { t } = useTranslation();

  const schema = yup.object({
    comments: yup.string().required(),
    disbursementDate: yup.date().required()
  });

  const handleSubmit = (values: DisbursementForm) => {
    const content: DisbursementContent = {
      disbursementDate: values.disbursementDate,
      comments: values.comments
    };

    onSubmit(content);
  };

  const handleCancel = (reset: HookFormMethods['reset']) => {
    reset({});

    onCancel();
  };

  return (
    <HookFormResolver onSubmit={handleSubmit} validations={schema}>
      {({ reset }: HookFormMethods) => (
        <>
          <IconTitle
            title={t('disbursement.register')}
            icon={InputCursorText}
            subtitle={t('disbursement.registerNote')}
          />
          <Row>
            <div className="col-12 col-md-6 col-lg-3">
              <Datepicker label={t('disbursement.disbursementDate')} name="disbursementDate" />
            </div>
            <div className="col-12">
              <TextArea rows={4} label={t('disbursement.disbursementComments')} name="comments" />
            </div>
          </Row>

          <BtnToolbar>
            <BtnGroup>
              <Button
                action={ButtonAction.cancel}
                variant="secondary"
                type="button"
                onClick={() => handleCancel(reset)}
              />
            </BtnGroup>

            <BtnGroup>
              <Button
                action={ButtonAction.save}
                type="submit"
                variant="primary"
                text={t('disbursement.disbursementCreate')}
              />
            </BtnGroup>
          </BtnToolbar>
        </>
      )}
    </HookFormResolver>
  );
};
